import { getStatePure, modifyState } from '~src/state';
import { getImageFromPage } from '~core';

export const ensureAllPagesHavePreview = async () => {
  const pages = getStatePure('pages', []);

  let hasChanges = false;

  for (const page of pages) {
    if (page.imgData) {
      continue;
    }

    try {
      page.imgData = await getImageFromPage(page);
      hasChanges = true;
    } catch (error) {
      console.warn('Cannot generate page preview', error);
    }
  }

  if (hasChanges) {
    await modifyState('pages', pages);
  }
};
